import { FC } from 'react';
import { Alert, Stack } from '@customink/pigment-react';
import { PWC } from '~/adapters/typescript/propsWithChildren';
import { useOptionalAuthUser } from '~/contexts/Auth/AuthContext';
import { usePersonalAccount } from '~/adapters/services/accounts/accounts/hooks';
import { useUserData } from '~/adapters/services/accounts/users/hooks';
import { FullLayoutLoader } from '~/components/Layout/FullLayoutLoader';
import { UserAccountContext } from './UserAccountContext';

export const UserAccountProvider: FC<PWC> = ({ children }) => {
    const { data: account, isLoading: isAccountLoading } = usePersonalAccount();
    const { data: user, isLoading: isUserLoading } = useUserData();
    const authUser = useOptionalAuthUser();

    if (isAccountLoading || isUserLoading) {
        return <FullLayoutLoader devLabel="User Account Provider" />;
    }

    if (authUser && authUser.impersonated && (!account || !user)) {
        return (
            <Stack direction="row" justifyContent="center">
                <Alert severity="error">
                    Impersonation error
                    <br />
                    No data found for {authUser.email}
                </Alert>
            </Stack>
        );
    }

    return <UserAccountContext.Provider value={{ account, user }}>{children}</UserAccountContext.Provider>;
};
